// extracted by mini-css-extract-plugin
export default {"modal_overlay":"RoleModal_modal_overlay__4gf7F","main_container":"RoleModal_main_container__unxxw","modal_title":"RoleModal_modal_title__H7+Px"};